<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-form name="get-offers-data">
            <div class="grid">
                <FormMultiselect fieldName="seller_ids"
                                 style="margin-top:5px"
                                 label="Sellers"
                                 showClear
                                 validation="required"
                                 :options="select?.sellers"
                                 v-model:field="seller_ids" />
            </div>

            <div class="grid">
                <FormMultiselect fieldName="marketplace_ids"
                                 label="Marketplaces"
                                 showClear
                                 validation="required"
                                 :options="select?.marketplaces"
                                 v-model:field="marketplace_ids" />
            </div>

            <div class="grid"
                 style="margin-top:20px">
                <Button severity="success"
                        style="margin:0 8px"
                        @click="getDataFromMarketplace">
                    <i class="fa-solid fa-box-open"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Get data from makretplaces') }}
                </Button>
                <Button severity="secondary"
                        style="margin:0 8px"
                        @click="cancel">
                    <i class="fa-solid fa-ban"
                       style="margin-right:5px;font-size:18px"></i>
                    {{ __('Cancel') }}
                </Button>
            </div>
        </v-form>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useForm } from '@inertiajs/vue3'
import Button from 'primevue/button';
import FormMultiselect from '@pages/Crud/FormMultiselect.vue'
import { prepareSelect, validation, onChangeService } from '@pages/Helper/crud_utils.js'
import { __, screenMessage, getFromRoute } from '@pages/Helper/utils.js'

// -----------------------------------------------------
const props = defineProps({
    formProps: Object,
})

const getDataModalOpen = defineModel('getDataModalOpen')
console.log(props.formProps)
// -----------------------------------------------------

const seller_ids = ref([])
const marketplace_ids = ref([])
const isLoading = ref(false);

let select = ref(null)

// -----------------------------------------------------

onMounted(async () => {
    select.value = await prepareSelect(['marketplaces', 'sellers']);
})

// -----------------------------------------------------

const cancel = () => {
    getDataModalOpen.value = false
}

// -----------------------------------------------------

const getDataFromMarketplace = async () => {
    const formData = {
        'seller_ids': seller_ids.value,
        'marketplace_ids': marketplace_ids.value
    }

    isLoading.value = true
    const response = await getFromRoute('offer-get-data', formData, 'post')
    isLoading.value = false

    if (!response) {
        return
    }

    getDataModalOpen.value = false
    const message = {
        message: response.message,
        title: "Information",
        type: "info",
        position: "center",
        timeout: 15,
    };
    screenMessage(message);

    props.formProps.getLazyData()

}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
